import { render, staticRenderFns } from "./order-international-information.vue?vue&type=template&id=90f1b59c&"
import script from "./order-international-information.vue?vue&type=script&lang=js&"
export * from "./order-international-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports